import React, { useMemo, lazy, Suspense } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { useStateModal } from 'utils/hooks';
import { getImagesWithArtDirection } from 'utils/images';

import * as styles from './Image.module.scss';

const PhotoGalleryModal = lazy(() => import('components/Modals/PhotoGalleryModal'));

export default function Image({ item, index, items }) {
  const { title, desktop, tablet, mobile } = item;
  const image = useMemo(
    () =>
      getImagesWithArtDirection({
        desktop,
        tablet,
        mobile,
      }),
    [desktop, tablet, mobile],
  );
  const { modalState, showModal, hideModal } = useStateModal();

  return (
    <>
      <div className={styles.item} onClick={showModal}>
        <GatsbyImage image={image} alt={title ?? 'photo'} className={styles.picture} />
      </div>
      {modalState.isOpen && (
        <Suspense fallback={null}>
          <PhotoGalleryModal
            isOpen={modalState.isOpen}
            closeModalCallback={hideModal}
            items={items}
            index={index}
          />
        </Suspense>
      )}
    </>
  );
}
